import { render, staticRenderFns } from "./PhotoUploadModal.vue?vue&type=template&id=4b71237e&scoped=true&"
import script from "./PhotoUploadModal.vue?vue&type=script&lang=js&"
export * from "./PhotoUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoUploadModal.vue?vue&type=style&index=0&id=4b71237e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71237e",
  null
  
)

export default component.exports